'use client';
import { useEffect, useRef, useState } from 'react';
import Slider from 'react-slick';
import { SvgArrowLeft, SvgArrowRight } from '../icons';
import { Button, ServiceCard } from '@/components';
import { backgroundColors, images, settings } from '@/components/servicesCarousel/ServicesCarousel.constants';
import { API_STATIC_FILES } from '@/utils/constants';
import { PopularMedicalService } from '@/api/popularMedicalService/popularMedicalService.types';
import s from './servicesCarousel.module.scss';
import { useViewport } from '@/hooks/useViewport';

interface Props {
  services: PopularMedicalService[];
}

export const ServicesCarousel = ({ services }: Props) => {
  const { isMobile, isLaptop } = useViewport();
  const sliderRef = useRef<Slider | null>(null);
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
  const [slidesToShow, setSlidesToShow] = useState(4.5);

  useEffect(() => {
    if (isLaptop) setSlidesToShow(3);
    if (isMobile) setSlidesToShow(1.5);
  }, [isMobile, isLaptop]);

  const isPrevDisabled = currentSlideIndex === 0;
  const isNextDisabled = currentSlideIndex >= services.length - slidesToShow;

  return (
    <div className={s.popularServices}>
      <div className={s.popularServices__head}>
        <h2 className={s.popularServices__title}>Популярные услуги</h2>
        <div className={s.popularServices__navArrows}>
          <Button
            name=""
            type="button"
            theme="arrow"
            size="small"
            leftIcon={<SvgArrowLeft />}
            onClick={() => sliderRef.current?.slickPrev()}
            disabled={isPrevDisabled}
          />
          <Button
            name=""
            type="button"
            theme="arrow"
            size="small"
            leftIcon={<SvgArrowRight />}
            onClick={() => sliderRef.current?.slickNext()}
            disabled={isNextDisabled}
          />
        </div>
      </div>
      <div className={s.sliderContainer}>
        <Slider
          {...settings}
          ref={sliderRef}
          beforeChange={(current: number, next: number) => setCurrentSlideIndex(next)}
          afterChange={(current) => setCurrentSlideIndex(current)}
        >
          {services.map((service, index) => {
            const icon = service.service_icon ? `${API_STATIC_FILES}${service.service_icon}` : images[index % images.length];
            return (
              <ServiceCard
                className={s.sliderContainer__card}
                key={service.id}
                service={service.service}
                backgroundColor={backgroundColors[index % backgroundColors.length]}
                imageSrc={icon}
              />
            );
          })}
        </Slider>
      </div>
    </div>
  );
};